import {
  ENTITLEMENTS_MANIFEST,
  getFeatureValue,
  getLimit,
  hasFeatureBoolean
} from "../chunk-UZRKHB62.mjs";
import "../chunk-XGB3TDIC.mjs";
export {
  ENTITLEMENTS_MANIFEST,
  getFeatureValue,
  getLimit,
  hasFeatureBoolean
};
